import { ITrafficSituation } from '../../../../../models/traffic-situation.model';

export class ValidityPeriodFactHelper {
  public static hasRegularValidityPeriod(trafficSituation: ITrafficSituation): boolean {
    return trafficSituation.startTime.isValid || (trafficSituation.endTime !== undefined && trafficSituation.endTime.isValid);
  }
}
